import { LogSafeValue, LogSafeValueImpl } from '@redngapps/shared/logging/types';

export function isLogSafeValue(value: any): value is LogSafeValue {
  return value instanceof LogSafeValueImpl;
}
